import type {
  TypeGetInboundRequestProgressParams,
  TypeGetReceivingReportHistoriesParams,
  TypeGetRequestGoodsParams,
  TypePostRequestsRequestedParams,
  TypePostStatusRequestedParams,
  TypeReturnDisposalListParams,
} from '~/types/receive.types';

/**
 * [입고관리] React Query Key Factory
 */
export const receiveKeys = {
  all: ['receive'] as const,

  /** 필터 옵션 조회 (useGetFilterAll) */
  filterAll: (screenName: string) => [...receiveKeys.all, 'filterAll', screenName] as const,

  /** 입고요청 목록 조회 (POST /requests/requested) */
  requestsRequested: (ownerCode: string, params: TypePostRequestsRequestedParams) =>
    [...receiveKeys.all, 'requestsRequested', ownerCode, params] as const,

  /** 입고요청 상세 조회 (GET /requests/requested/:id) */
  requestsRequestedDetail: (ownerCode: string, requestId: string) =>
    [...receiveKeys.all, 'requestsRequestedDetail', ownerCode, requestId] as const,

  /** 입고상품추가 모달 > 상품 조회 (GET /request/goods) */
  requestGoods: (ownerCode: string, params: TypeGetRequestGoodsParams) =>
    [...receiveKeys.all, 'requestGoods', ownerCode, params] as const,

  /** 입고현황 목록 조회 (GET /receiving/:ownerCode/progress) */
  receivingProgress: (ownerCode: string, params: TypePostStatusRequestedParams) =>
    [...receiveKeys.all, 'receivingProgress', ownerCode, params] as const,

  /** 3PL 입고현황 목록 조회 (GET /receiving/:ownerCode/inbound-request/progress) */
  inboundRequestProgress: (ownerCode: string, params: TypeGetInboundRequestProgressParams) =>
    [...receiveKeys.all, 'inboundRequestProgress', ownerCode, params] as const,

  /** 입고 리포트 목록 조회 (GET /receiving/:ownerCode/report/histories) */
  reportHistories: (ownerCode: string, params: TypeGetReceivingReportHistoriesParams) =>
    [...receiveKeys.all, 'reportHistories', ownerCode, params] as const,

  /** 회송/폐기 관리 목록 조회 (GET /receiving-return/issues) */
  returnDisposalIssues: (params: TypeReturnDisposalListParams) =>
    [...receiveKeys.all, 'returnDisposalIssues', params] as const,

  /** 회송/폐기 관리 상세 조회 (GET /receiving-return/issues/:inspectionId) */
  returnDisposalDetail: (inspectionId: number) => [...receiveKeys.all, 'returnDisposalDetail', inspectionId] as const,

  /** 회송/폐기 관리 상태 변경 이력 (GET /receiving-return/issues/:inspectionId/status-histories) */
  returnDisposalStatusHistories: (inspectionId: number) =>
    [...receiveKeys.all, 'returnDisposalStatusHistories', inspectionId] as const,

  /** 회송/폐기 처리신청 상품정보 미리보기 (GET /receiving-return/issue-items) */
  returnDisposalIssueItems: (inspectionIds: number[]) =>
    [...receiveKeys.all, 'returnDisposalIssueItems', inspectionIds] as const,

  /** 회송/폐기 회수예정일 조회 (GET /receiving-return/operation-times) */
  returnDisposalOperationTimes: (inspectionIds: number[], rtsMethod: string) =>
    [...receiveKeys.all, 'returnDisposalOperationTimes', inspectionIds, rtsMethod] as const,

  /** 회송/폐기 회수 처리 입고지(회수지) 주소 조회 (GET /receiving-return/inbound-area) */
  returnDisposalInboundArea: (inspectionIds: number[]) =>
    [...receiveKeys.all, 'returnDisposalInboundArea', inspectionIds] as const,

  /** 회송/폐기 코드 조회 (GET /codes) */
  returnDisposalCodes: (codeGroup: string) => [...receiveKeys.all, 'returnDisposalCodes', codeGroup] as const,

  /** 회송/폐기 GNB 미처리 건수 조회 (GET /receiving-return/issues/pending/count) */
  returnDisposalUnprocessedCount: () => [...receiveKeys.all, 'returnDisposalUnprocessedCount'] as const,
};
